module.exports = __webpack_public_path__ + "public/img/import.b04bcd23.png";